/** Screen name for a route, longest prefix first, so "/data-connectors/x/data-studio" reads as Data studio. */
const SCREEN_LABELS: readonly { pattern: RegExp; label: string }[] = [
  { pattern: /^\/workspace\/[^/]+\/story\/[^/]+\/(build|generate)(\/|$)|^\/(build|story\/generate)\//, label: "Story, build" },
  { pattern: /^\/workspace\/[^/]+\/story\/[^/]+\/explore(\/|$)|^\/explore\/[^/]+\//, label: "Story, explore" },
  { pattern: /^\/workspace\/[^/]+\/story\/[^/]+\/present(\/|$)|^\/present\//, label: "Story, present" },
  { pattern: /^\/workspace\/[^/]+\/story(\/|$)|^\/story\//, label: "Story" },
  { pattern: /^\/data-connectors\/[^/]+\/data-studio(\/|$)|^\/data-studio(\/|$)/, label: "Data studio" },
  { pattern: /^\/data-connectors\/[^/]+\/tables(\/|$)/, label: "Table" },
  { pattern: /^\/data-connectors(\/|$)/, label: "Data connectors" },
  { pattern: /^\/(home|home-legacy|home-old)(\/|$)/, label: "Home" },
  { pattern: /^\/stories(\/|$)/, label: "Stories" },
  { pattern: /^\/settings(\/|$)/, label: "Settings" },
  { pattern: /^\/agents(\/|$)/, label: "Agents" },
  { pattern: /^\/alerts(\/|$)/, label: "Alerts" },
  { pattern: /^\/activity(\/|$)/, label: "Activity" },
  { pattern: /^\/templates(\/|$)/, label: "Templates" },
  { pattern: /^\/knowledge-graph(\/|$)/, label: "Knowledge graph" },
  { pattern: /^\/folders(\/|$)/, label: "Folders" },
  { pattern: /^\/(dashboard|analysis|automation|interact|experience)(\/|$)/, label: "Dashboard" },
  { pattern: /\/data-models(\/|$)/, label: "Data models" },
  { pattern: /\/data-sources(\/|$)/, label: "Data sources" },
  { pattern: /\/business-rules(\/|$)/, label: "Business rules" },
  { pattern: /\/distributions(\/|$)/, label: "Distributions" },
  { pattern: /\/artifacts(\/|$)/, label: "Artifacts" },
  { pattern: /^\/workspaces?(\/|$)/, label: "Workspaces" },
];

/** A readable name for the screen at `pathname`; a generic fallback ("this screen") for unknown routes. */
export const screenLabelForPath = (pathname: string, fallback = "This screen"): string =>
  SCREEN_LABELS.find(({ pattern }) => pattern.test(pathname))?.label ?? fallback;
